import product from './product'
import config from './config'

export default {
    product,
    config
}
